<p-dialog
  [visible]="displayModal"
  [modal]="true"
  [resizable]="false"
  [style]="{ width: '700px' }"
  (visibleChange)="onCanceled()"
  header="{{ 'ARC_PAYMENT_PAD_AGREEMENT_DIALOG_HEADER' | translate }}"
>
  <form id="padForm" [formGroup]="padForm" novalidate>
    <div class="grid">
      <form
        id="payor-details"
        class="col-12 md:col-6"
        [formGroup]="payorDetailsGroup"
      >
        <h5>{{ 'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS' | translate }}</h5>

        <div>
          <aur-input
            id="pad-signature-first-name-input"
            class="full-width"
            tooltip="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_SIGNATURE_FIRST_NAME_TOOLTIP'
                | translate
            }}"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_SIGNATURE_FIRST_NAME'
                | translate
            }}"
            formControlName="firstName"
          >
          </aur-input>
        </div>
        <div>
          <aur-input
            id="pad-signature-last-name-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_SIGNATURE_LAST_NAME'
                | translate
            }}"
            formControlName="lastName"
          >
          </aur-input>
        </div>
        <div>
          <aur-input
            id="pad-signature-email-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_EMAIL' | translate
            }}"
            formControlName="emailAddress"
          >
          </aur-input>
        </div>
        <div>
          <aur-input
            id="business-name-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_BUSINESS_NAME'
                | translate
            }}"
            formControlName="businessName"
          >
          </aur-input>
        </div>
        <div *ngIf="isSetInterval">
          <aur-input
            id="business-number-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_BUSINESS_NUMBER'
                | translate
            }}"
            formControlName="businessNumber"
          >
          </aur-input>
        </div>
        <div>
          <aur-input
            id="business-address-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_BUSINESS_ADDRESS'
                | translate
            }}"
            formControlName="address"
          >
          </aur-input>
        </div>

        <div>
          <div id="billing-information">
            <aur-address-group
              id="aur-address"
              formGroupName="billingInformation"
            >
            </aur-address-group>
          </div>
        </div>

        <div *ngIf="isSetInterval">
          <aur-input
            id="contact-name-input"
            class="full-width"
            tooltip="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_CONTACT_NAME_TOOLTIP'
                | translate
            }}"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_CONTACT_NAME' | translate
            }}"
            formControlName="contactName"
          >
          </aur-input>
          <aur-input
            id="contact-title-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_CONTACT_TITLE'
                | translate
            }}"
            formControlName="contactTitle"
          >
          </aur-input>
          <aur-input
            id="contact-telephone-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_DETAILS_CONTACT_PHONE'
                | translate
            }}"
            formControlName="contactTelephoneNumber"
          >
          </aur-input>
        </div>
      </form>

      <form
        id="payor-bank-account-details"
        class="col-12 md:col-6"
        [formGroup]="payorBankAccountDetailsGroup"
      >
        <h5>
          {{ 'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_BANK_ACCT_DETAILS' | translate }}
        </h5>

        <div>
          <aur-input
            id="bank-financial-institution-name-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_BANK_ACCT_DETAILS_INST_NAME'
                | translate
            }}"
            formControlName="institutionName"
          >
          </aur-input>
        </div>
        <div *ngIf="isSetInterval">
          <aur-input
            id="bank-institution-address-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_BANK_ACCT_DETAILS_INST_ADDRESS'
                | translate
            }}"
            formControlName="institutionAddress"
          >
          </aur-input>
        </div>
        <div id="bank-billing-information" *ngIf="isSetInterval">
          <aur-address-group
            id="aur-address"
            formGroupName="bankBillingInformation"
          >
          </aur-address-group>
        </div>
        <div>
          <aur-input
            id="bank-transit-number-input"
            [errorMessages]="errorMessages"
            [aurMask]="'00000'"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_BANK_ACCT_DETAILS_TRANSIT_NUMBER'
                | translate
            }}"
            formControlName="transitNumber"
          >
          </aur-input>
        </div>
        <div>
          <aur-input
            id="bank-institution-number-input"
            [errorMessages]="errorMessages"
            [aurMask]="'000'"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_BANK_ACCT_DETAILS_INST_NUMBER'
                | translate
            }}"
            formControlName="institutionNumber"
          >
          </aur-input>
        </div>
        <div>
          <aur-input
            id="bank-account-number-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_BANK_ACCT_DETAILS_ACCT_NUM'
                | translate
            }}"
            formControlName="bankAccountNumber"
          >
          </aur-input>
        </div>
        <div *ngIf="isSetInterval">
          <aur-input
            id="bank-telephone-number-input"
            class="full-width"
            label="{{
              'ARC_PAYMENT_PAD_AGREEMENT_PAYOR_BANK_ACCT_DETAILS_PHONE'
                | translate
            }}"
            formControlName="bankTelephoneNumber"
          >
          </aur-input>
        </div>
      </form>
    </div>
  </form>

  <p-footer>
    <button
      id="cancel-pad-agreement"
      aur-button
      type="button"
      importance="secondary"
      (click)="onCanceled()"
    >
      {{ 'ARC_PAYMENT_BACK' | translate }}
    </button>
    <button
      aur-button
      id="submit-pad-agreement"
      type="button"
      importance="primary"
      (click)="onSubmit()"
    >
      {{ 'ARC_PAYMENT_PAD_AGREEMENT_PROCEED_REVIEW_PAD' | translate }}
    </button>
  </p-footer>
</p-dialog>
